import {useApiLoader} from '@/Hooks';
import {API} from '@/API/API';

const useGetCampaign = () => {
  return useApiLoader(async (campaignID: number) => {
    return await API.Campaigns.getCampaign(campaignID);
  }, []);
};
export default useGetCampaign;
